import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { DownloadIcon, BanIcon } from "@heroicons/react/solid";
import { LoginContext } from "../../../../contexts/LoginContext";
import Contributors from "../../../../components/teacher/ongoing/Contributors";
import ProjectDetails from "../../../../components/teacher/ongoing/ProjectDetails";
import ProjectModal from "../../../../components/modals/ProjectModal";
import routes from "../../../../config/routes-config";
import {
  closeOngoingProject,
  deleteOngoingProject,
  fetchOngoingProjectDetails,
  updateOngoingProjectDeadline,
} from "./api-handlers";

const OngoingProjectDetails = ({ projectType }) => {
  const [ongoingProjectDetails, setOngoingProjectDetails] = useState({});

  const { userAuthStatus, user } = useContext(LoginContext);

  const { ongoingProjectId } = useParams();

  useEffect(() => {
    if (userAuthStatus && user !== null) {
      // fetchOngoingProjectDetails(
      //   routes.teacher.ongoingProjects.ongoingProjectDetailsUrl +
      //     `?projectId=${ongoingProjectId}`,
      //   user.token,
      //   setOngoingProjectDetails
      // );

      // TODO :: Testing purpose only. Please remove it after that
      fetchOngoingProjectDetails(
        routes.teacher.ongoingProjects.ongoingProjectDetailsUrl +
          `?projectId=0}`,
        user.token,
        setOngoingProjectDetails
      );
    }
  }, [userAuthStatus, user, ongoingProjectId]);

  const [isProjectModalOpened, setProjectModalOpened] = useState({
    isCloseProjectModalOpened: false,
    isDeleteProjectModalOpened: false,
  });

  const handleProjectModal = (propertyName, value) => {
    setProjectModalOpened((previousValue) => {
      return { ...previousValue, [propertyName]: value };
    });
  };

  return (
    <>
      <div className="w-[calc(100vw-8.5rem)] bg-[#ECECEC] py-8 px-32">
        <div className="mb-8">
          <h1 className="text-2xl font-semibold text-[#1E1E4A]">
            Ongoing Projects
          </h1>
        </div>
        <div className="w-auto h-screen bg-white border-gray-100 rounded-xl py-6 px-20">
          <div>
            <h1 className="text-2xl font-semibold text-[#555555] text-center mb-8">
              {projectType} 2021-22 Sem2
            </h1>
          </div>

          <div className="flex flex-row justify-between align-top">
            <ProjectDetails project={ongoingProjectDetails} />
            <Contributors
              guide={{
                projectGuideId: ongoingProjectDetails.projectGuideId,
                projectGuideName: ongoingProjectDetails.projectGuideName,
              }}
              contributors={ongoingProjectDetails.projectContributorsList}
            />
          </div>

          <div className="flex flex-row mt-4">
            <h1 className="text-[#1C42D5] w-32">Photo</h1>
            <img
              className="h-44"
              src="https://www.liquidplanner.com/wp-content/uploads/2019/04/HiRes-17.jpg"
              alt="project"
            />

            <div className="flex flex-col ml-8">
              <button
                type="submit"
                className="mb-2 bg-[#B2B7FF] text-white font-bold rounded-xl flex flex-row py-1 px-4 justify-left"
              >
                <BanIcon className="h-6" />
                <h1 className="mx-5">Paper</h1>
              </button>
              <button
                type="submit"
                className="bg-[#B2B7FF] text-white font-bold rounded-xl flex flex-row py-1 px-4 justify-left"
              >
                <BanIcon className="h-6" />
                <h1 className="mx-5">PPT</h1>
              </button>
            </div>
          </div>
          <div className="flex flex-col items-center mt-10">
            <div className=" flex w-[calc(100vw-28rem)] border-t border-gray-400"></div>
          </div>
          <div className="flex flex-row mt-4 justify-end">
            <button
              type="button"
              onClick={() =>
                handleProjectModal("isCloseProjectModalOpened", true)
              }
              className="mr-2 p-1 bg-[#8389ff] hover:bg-[#4242A8] text-white font-bold rounded-full flex flex-row px-2 justify-center"
            >
              <h1 className="mx-5">Close Project</h1>
            </button>

            <ProjectModal
              confirmationText={`Are you sure you want to close the ${projectType} Project with project-id ${ongoingProjectId}.`}
              isOpened={isProjectModalOpened.isCloseProjectModalOpened}
              onConfirmationCallback={() => {
                handleProjectModal("isCloseProjectModalOpened", false);
                closeOngoingProject(
                  routes.teacher.ongoingProjects.closeProject,
                  user.token
                );
              }}
              onCloseCallback={() =>
                handleProjectModal("isCloseProjectModalOpened", false)
              }
            />

            <button
              type="button"
              onClick={() =>
                handleProjectModal("isDeleteProjectModalOpened", true)
              }
              className="p-1 bg-[#FF6464] hover:bg-[#da5656] text-white font-bold rounded-full flex flex-row px-2 justify-center"
            >
              <h1 className="mx-5">Delete Project</h1>
            </button>

            <ProjectModal
              confirmationText={`Are you sure you want to delete the ${projectType} Project with project-id ${ongoingProjectId}.`}
              isOpened={isProjectModalOpened.isDeleteProjectModalOpened}
              onConfirmationCallback={() => {
                handleProjectModal("isDeleteProjectModalOpened", false);
                deleteOngoingProject(
                  routes.teacher.ongoingProjects.deleteProject,
                  user.token
                );
              }}
              onCloseCallback={() =>
                handleProjectModal("isDeleteProjectModalOpened", false)
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default OngoingProjectDetails;
